export default "__VITE_ASSET__Boe$qF0n__";